/*
 * @Description:
 * @Date: 2022-04-19 16:03:38
 */
import { ref, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { defineStore } from 'pinia';
import { removeEmpty } from '@/utils/formatter';
import { RouteQuery } from '../types/index';

export const useFormManageStore = defineStore(
  'formManageStore',
  () => {
    const routeQuery = ref<RouteQuery>(null);
    const setRouteQuery = data => {
      routeQuery.value = removeEmpty(data);
    };
    const initRouteQuery = () => {
      routeQuery.value = null;
      nextTick(() => {
        window.sessionStorage.removeItem('formManageStore');
      });
    };

    const router = useRouter();
    const push = data => {
      if (data?.query) setRouteQuery(data.query);
      router.push({
        name: data?.name,
        path: data?.path
      });
    };

    return {
      routeQuery,
      setRouteQuery,
      initRouteQuery,
      push
    };
  },
  {
    persist: {
      storage: sessionStorage
    }
  }
);
